import React from 'react'
import MangerLayer from '../components/manger/MangerLayer'
import MasterLayout from "../masterLayout/MasterLayout";

const MangerPage = () => {
  return (
    <MasterLayout>
    <MangerLayer/>
    </MasterLayout>
  )
}

export default MangerPage